export enum BrandTab {
  About = 'about',
  Logos = 'logos',
  Colors = 'colors',
  FormItems = 'form-items',
  ButtonItems = 'buttons-and-links'
}

export enum BrandLogoType {
  Square = 'square',
  Horizontal = 'horizontal'
}
